import apiInstance from "./apiService";

interface VerifyOtpPayload {
  email: string;
  otp: string;
  osType: string;
  udid: string;
  appVersion: string;
  deviceName: string;
  pnTok: string;
  pnvTok: string;
}

interface AuthTokens {
  access: { token: string; user_id: string };
  refresh: { token: string };
}

export interface VerifyOtpResponseData {
  message: string;
  data: AuthTokens;
  signup: boolean;
  email: string;
  isPhoneRegistered: boolean;
  isPurchasedNumber: boolean;
}

const verifyOtpEndpoint = "auth/email/verify-code";
const resendOtpEndpoint = "auth/email/request-code";

export const authService = {
  async verifyEmailOtp(
    payload: VerifyOtpPayload,
  ): Promise<{ status: number; data: VerifyOtpResponseData }> {
    const res = await apiInstance.post<VerifyOtpResponseData>(
      verifyOtpEndpoint,
      payload,
    );
    return { status: res.status, data: res.data };
  },

  async resendOtp(email: string): Promise<{ status: number }> {
    const res = await apiInstance.post(resendOtpEndpoint, { email });
    return { status: res.status };
  },
};
